// renameNamedWindow — VQE-Edit edit-action: rename a `WINDOW w AS (…)`
// definition's name via SR-Edit's `rename-named-window` op (replaces the name
// token only — window-name references in OVER clauses are left to the user, as
// the resolver does not coordinate-rename them yet).
//
// Task: VQE Polish §4b-ii — named-window card real editing.

import { commitEdit, type CommitEditCtx } from '../commitEdit';

const IDENT_PATTERN = /^[A-Za-z_][A-Za-z0-9_$]*$|^"[^"]*"$|^`[^`]*`$|^\[[^\]]*\]$/;

export async function renameNamedWindow(
  index: number,
  newName: string,
  ctx: CommitEditCtx,
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`renameNamedWindow: index must be a non-negative integer (got ${index})`);
  }
  const trimmed = newName.trim();
  if (trimmed.length === 0) throw new Error('renameNamedWindow: newName must not be empty');
  if (!IDENT_PATTERN.test(trimmed)) {
    throw new Error(
      `renameNamedWindow: newName "${trimmed}" is not a valid identifier (use bare letters/digits/underscores or a quoted form)`,
    );
  }
  await commitEdit({ op: 'rename-named-window', index, newName: trimmed }, ctx);
}
